import React, { useState, useEffect } from "react";

import { Field } from "formik";

import { Container, OptionsContainer, CheckboxInput } from "./styles";

import TplGroup from "../tpl-group";

import IField from "../../../../interfaces/field";

type IProps = any & IField;

const InputCheck: React.FC<IProps> = ({
  required = false,
  name,
  prefixName = "",
  title,
  options,
  onChange,
  checked = false,
  ...el
}: IProps) => {
  const [selectedOptions, setSelectedOptions] = useState<Set<string>>(
    new Set()
  );

  useEffect(() => {
    if (checked) {
      setSelectedOptions(
        new Set(options.map((option: any) => String(option.value)))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  useEffect(() => {
    if (checked && el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, Array.from(selectedOptions));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions, checked]);

  const handleOptionClick = (value: string): void => {
    const newSelectedOptions = new Set(selectedOptions);

    if (newSelectedOptions.has(value)) {
      newSelectedOptions.delete(value);
    } else {
      newSelectedOptions.add(value);
    }
    setSelectedOptions(newSelectedOptions);
    if (onChange) {
      onChange(Array.from(newSelectedOptions), el);
    }

    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, Array.from(newSelectedOptions));
    }
  };

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      onChange={onChange}
      {...el}
    >
      <Container>
        <OptionsContainer>
          {options.map((option: any) => (
            <label
              key={JSON.stringify(option)}
              htmlFor={`${prefixName}${name}-${option.value}`}
            >
              <Field
                type="checkbox"
                name={`${prefixName}${name}-${option.value}`}
                value={String(option.value)}
                as={CheckboxInput}
                checked={selectedOptions.has(String(option.value))}
                onChange={() => handleOptionClick(String(option.value))}
                disabled={el?.disabled === true}
              />
              <div>{option?.name || option}</div>
            </label>
          ))}
        </OptionsContainer>
      </Container>
    </TplGroup>
  );
};

export default InputCheck;
